import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  updateTables,
  clearTables,
} from 'containers/Entity/actions'

import {
  get,
  patch,
  post
} from 'helpers/RequestUtil'

import {
  FETCH_SUPPORT_TEAM,
  POST_SUPPORT_TEAM,
} from './constants'

import {
  supportTeamSelector,
  supportTeamChanges,
} from './selectors'

import {
  updateSupportTeam,
  updateSupportTeamChange,
  fetchSupportTeam as fetchSupportTeamAction,
  fetchSupportTeamStart,
  fetchSupportTeamSuccess,
  fetchSupportTeamError,
  postSupportTeamStart,
  postSupportTeamSuccess,
  postSupportTeamError,
} from './actions'

function* fetchSupportTeam(projectId) {
  try {
    yield put(fetchSupportTeamStart())
    const data = yield call(get, `/api/fulcrum/projects/${projectId}/support_teams`)
    const { result: { project_support_team_views: supportTeams } } = data
    yield put(updateTables(data))
    yield put(fetchSupportTeamSuccess(supportTeams))
    return supportTeams
  } catch(error) {
    yield put(fetchSupportTeamError(error))
  }
}

function* postSupportTeam(projectId, team) {
  try {
    yield put(postSupportTeamStart())
    const postRequest = post('project_support_teams', { team })
    yield call(postRequest, `/api/fulcrum/projects/${projectId}/support_teams`)
    yield put(postSupportTeamSuccess())
  } catch(error) {
    yield put(postSupportTeamError(error))
  }
}

function* handleFetchSupportTeam(action) {
  const { projectId } = action
  const supportTeams = yield call(fetchSupportTeam, projectId)
  yield put(updateSupportTeam(supportTeams))
  const team = yield select(supportTeamSelector)
  yield put(updateSupportTeamChange(team))
}

function* handlePostSupportTeam(action) {
  const { projectId } = action
  const team = yield select(supportTeamChanges)
  yield call(postSupportTeam, projectId, team)
  yield put(fetchSupportTeamAction(projectId))
}

function* watchFetchSupportTeam() {
  yield takeEvery(FETCH_SUPPORT_TEAM, handleFetchSupportTeam)
}

function* watchPostSupportTeam() {
  yield takeEvery(POST_SUPPORT_TEAM, handlePostSupportTeam)
}

function* loadSagas() {
  yield all([
    fork(watchFetchSupportTeam),
    fork(watchPostSupportTeam)
  ])
}

export default loadSagas
export {
  handleFetchSupportTeam
}